module.exports = __webpack_public_path__ + "static/media/asesoria en materia legislativa 1 (1).5b8d8005.mp4";